function init() {

    var forms = document.querySelectorAll('.smx-booking-form form');

    if(forms.length > 0){
        window.utils.forEach(forms, function (index, form) {
            const serviceSelect = form.querySelector('#smx-service');
            const expertSelect = form.querySelector('#smx-expert');
            const allOptions = Array.from(expertSelect.options);

            serviceSelect.addEventListener('change', function () {
                const selectedService = serviceSelect.value;

                allOptions.forEach(option => {
                    if (option.value === 'all') {
                        option.disabled = false; // Sempre abilitata
                        return;
                    }

                    const specs = option.getAttribute('data-services') || '';
                    const specsArray = specs.split(',').map(s => s.trim());

                    // Abilita se il valore selezionato è incluso nei data-specs
                    option.disabled = !specsArray.includes(selectedService);
                });
            });
        })
    }

}

export default { init };
